import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _MaterialAvailableProductionOrder, _MaterialAvailableProductionSelect } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";

interface Props {
    idProductionOrder: any;
    productionOrderDate: any;
}

export const MaterialAvailableProductionOrder = ({ idProductionOrder, productionOrderDate }: Props) => {

    const entailment = useDataBean(_MaterialAvailableProductionOrder);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])

    const getLista = () => {

        entailment.instance.getRawMaterialAvailableProductionOrderCatalog(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((item) => {
                        item.DataBeanProperties.UnitName = (item.DataBeanProperties.MeasurementUnitCode ?? "") + "-" + (item.DataBeanProperties.MeasurementUnitName ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        entailment.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        entailment.deleteItemVoid(entailment.bean.IDProduct).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        entailment.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProduct', visible: true },

        { title: 'Nombre', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'UnitName', visible: true },
        // { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Cantidad Total', property: 'TotalQuantity', visible: true },
        { title: 'Costo de Producto', property: 'ProductCost', visible: true },
        { title: 'Costo Total', property: 'TotalCost', visible: true },
    ]

    // const iconButtonsItem = [
    //     { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    // ]
    // const listaBotones = () => {
    //     const botones = [
    //         { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${entailment.bean.Name}`, "view": true }) } },
    //         { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

    //     ]
    //     return (
    //         <ListMenu listaBotones={botones} />
    //     )
    // }


    return (
        <BasicPage titulo="Inventario Disponible en Orden de Producción">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={entailment.setBean}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">


                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={entailment.bean.Code} onChange={entailment.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={entailment.bean.Name} onChange={entailment.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {entailment.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}